import Body from "@/body";
import App from "@/components/app";
new Body().setup();
// const bgElem = document.getElementById("bg");
// if (bgElem) {
//   new Bg(bgElem).setup();
// }
var appElem = document.getElementById("app");
if (appElem) {
    new App(appElem).setup();
}
